<template>
	<v-container fluid class="downloads-shell">
		<Loader v-if="pending" />

		<h3 v-else-if="files.length == 0" class="text-center text-h5" v-t="'descargas.vacio'" ></h3>

		<template v-else>
			<div class="downloads-page">
				<v-sheet rounded="xl" class="downloads-header mb-6" elevation="0">
					<div class="d-flex flex-wrap justify-space-between align-center">
						<div>
							<div class="eyebrow">Documentación</div>
							<h2 class="downloads-title mb-0">Zona de descargas</h2>
						</div>
						<v-chip class="downloads-badge" color="primary" variant="flat" small>
							{{ files.length }} archivos
						</v-chip>
					</div>
				</v-sheet>

				<v-row class="mb-2">
					<v-col cols="12" md="4" :offset-md="comer.length > 1 ? 2 : 4" sm="6" :offset-sm="comer.length > 1 ? 0 : 3">
						<v-text-field
							:placeholder="$t('common.busqueda')"
							solo
							hide-details
							v-model="filtro.titulo"
							class="search-field"
						>
							<template v-slot:prepend-inner>
								<v-icon color="primary">mdi-magnify</v-icon>
							</template>
						</v-text-field>
					</v-col>
					<v-col v-if="comer.length > 1" cols="12" md="4" sm="6">
						<v-select
							hide-details
							solo
							clearable
							:placeholder="`[${$t('descargas.comers')}]`"
							:items="comer"
							v-model="filtro.comer"
							class="select-field"
						></v-select>
					</v-col>
				</v-row>

				<div class="downloads-grid">
					<v-card
						@click.stop="download(f)"
						:key="f.ref"
						v-for="f in filesFiltered"
						width="100%"
						max-width="688"
						class="download-card"
					>
						<div class="card-header">
							<div class="brand-wrap">
								<img
									class="brand-logo"
									:src="`${$store.getters.getTenant.intranet}/imagenes/${f.imagen}`"
								/>
								<div class="brand-meta">
									<span class="card-title">{{ f.titulo }}</span>
										<span class="card-date">{{ formatDate(f.fecha) }}</span>
								</div>
							</div>
							<v-icon color="primary" class="download-icon">mdi-download</v-icon>
						</div>

						<v-card-subtitle class="card-description">
							{{ f.descripcion }}
						</v-card-subtitle>

						<div class="card-footer">
							<v-chip
								v-if="comer.length > 1 && f.comercializadora"
								label
								small
								color="primary"
								class="download-chip"
							>
								{{ f.comercializadora }}
							</v-chip>
						</div>
					</v-card>
				</div>
			</div>
		</template>
	</v-container>
</template>

<style scoped>


.downloads-page {
	max-width: 1100px;
	margin: 0 auto;
}

.downloads-header {
	padding: 24px 28px;
	color: black;
	background: rgba(255, 255, 255, 0.92);
	border: 1px solid rgba(255, 255, 255, 0.18);
}

.eyebrow {
	font-size: 0.72rem;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	opacity: 0.85;
	font-weight: 700;
}

.downloads-title {
	font-weight: 700;
	letter-spacing: -0.04em;
	font-size: clamp(1.6rem, 2vw, 2.4rem);
}

.downloads-badge {
	font-weight: 700;
	border-radius: 999px;
	color: white !important;
}

.search-field,
.select-field {
	border-radius: 18px;
}

.search-field >>> .v-input__slot,
.select-field >>> .v-input__slot {
	background: rgba(255, 255, 255, 0.88) !important;
	border-radius: 18px !important;
	box-shadow: 0 10px 24px rgba(31, 41, 55, 0.08) !important;
	border: 1px solid rgba(99, 102, 241, 0.12);
}

.downloads-grid {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 18px;
}

.download-card {
	border-radius: 22px !important;
	overflow: hidden;
	background: rgba(255, 255, 255, 0.92);
	backdrop-filter: blur(4px);
	border: 1px solid rgba(148, 163, 184, 0.18);
	box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	cursor: pointer;
	padding-top: 0;
}

.download-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 20px 38px rgba(15, 23, 42, 0.12);
}

.card-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	padding: 18px 18px 10px;
}

.brand-wrap {
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
}

.brand-logo {
	width: 42px;
	height: 42px;
	object-fit: contain;
	border-radius: 12px;
	background: linear-gradient(135deg, #f8fafc, #e2e8f0);
	padding: 6px;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
	flex-shrink: 0;
}

.brand-meta {
	display: flex;
	flex-direction: column;
	min-width: 0;
}

.card-title {
	display: block;
	font-size: 1.05rem;
	font-weight: 700;
	line-height: 1.4;
	color: rgba(15, 23, 42, 0.95);
	word-break: break-word;
}

.card-date {
	margin-top: 4px;
	font-size: 0.76rem;
	font-weight: 500;
	letter-spacing: 0.02em;
	color: rgba(100, 116, 139, 0.9);
}

.download-icon {
	margin-top: 4px;
	font-size: 1.55rem !important;
}

.card-description {
	padding: 0 18px 14px !important;
	color: rgba(71, 85, 105, 0.9) !important;
	line-height: 1.6;
	font-size: 0.95rem !important;
}

.card-footer {
	padding: 0 18px 18px;
}

.download-chip {
	font-weight: 600;
	border-radius: 999px !important;
}

.empty-state {
	max-width: 540px;
	margin: 24px auto 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 42px 24px;
	background: rgba(255, 255, 255, 0.72);
	border-color: rgba(148, 163, 184, 0.3) !important;
}

@media (max-width: 600px) {
	.downloads-shell {
		padding-top: 16px !important;
	}

	.downloads-header {
		padding: 18px 18px;
	}

	.card-header {
		padding: 16px 16px 8px;
	}

	.card-description {
		padding: 0 16px 12px !important;
	}

	.card-footer {
		padding: 0 16px 16px;
	}
}
</style>
<script setup>
import { downloadFile } from "@/utils/index.js";
import axios from '@/utils/axiosWrapper'
import { computed, getCurrentInstance, reactive } from "vue";
import Loader from '@/components/Loader.vue'

const root = getCurrentInstance().proxy.$root
const i18n = getCurrentInstance().proxy.$i18n

const { data: files, refresh, pending } = axios({
	method: 'GET',
	url: 'zona_descargas',
	default: () => ([])
})

const comer = computed(() => ([...new Set(files.value.map(f => f.comercializadora))]))

const filtro = reactive({
	titulo: '',
	comer: null,
})

const filesFiltered = computed(() => {
	const texto = (filtro.titulo || '').trim().toLowerCase()

	return [...files.value]
		.filter(f => {
			const titulo = (f?.titulo || '').toLowerCase()
			return titulo.includes(texto) && (filtro.comer ? f?.comercializadora == filtro.comer : true)
		})
		.sort((a, b) => {
			const fechaA = a?.fecha ? new Date(a.fecha).getTime() : 0
			const fechaB = b?.fecha ? new Date(b.fecha).getTime() : 0
			return fechaB - fechaA
		})
})

function formatDate(value) {
	if (!value) return ''

	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return value

	return new Intl.DateTimeFormat('es-ES', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	}).format(date)
}

async function download({ ref, archivo, ruta }) {
	const { data, error, refresh } = axios({
		url: `zona_descargas/${ref}`,
		responseType: 'blob',
		block: true,
		lazy : true,
	})
	await refresh();

	if ( error.value ) {
		root.$emit('snack', i18n.t('documentacion.not_found'), { color: 'error' })
		return
	}

	const ext = ruta.split('.')[ ruta.split('.').length - 1 ]

	const file = new File([data.value], `${archivo}.${ext}`)

	downloadFile(file)
}

</script>